module.exports = __webpack_public_path__ + "img/gh-36330m-1.prt.ce20292e.jpg";